import { NotificationType } from "@/Modules/App/Models/Domain/NotificationType";
import type { AgentRatingApiQuery } from "@/Modules/Agent/Models/Api";
import type { RatingQuery } from "@/Modules/Models/Domain/ClinicalHistory";

import { sendRating } from "@/Services/TherapyApi/Agent";

import useAgentStore from "@/Modules/Agent/Store";
import useAppStore from "@/Modules/App/Store";

import { snake } from "@/Utils/Snakelize";

async function sendRatingAH(ratingId: string, ratingData: RatingQuery) {
  const appStore = useAppStore();
  const agentStore = useAgentStore();

  agentStore.isSavingRating = true;

  try {
    const apiQuery = snake<RatingQuery, AgentRatingApiQuery>(ratingData);

    await sendRating(ratingId, apiQuery);

    agentStore.setRatingModalVisible(null);

    appStore.showSnackbar({
      message: "patients.clinical_documentation.transcription.rating.saved_notification",
      type: NotificationType.SUCCESS,
    });
  } catch (error: unknown) {
    appStore.showSnackbar({
      type: NotificationType.ERROR,
      message: "there_was_an_error_connecting_to_the_server_please_try_again_later",
    });
  } finally {
    agentStore.isSavingRating = false;
  }
}

export default sendRatingAH;
